import React from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { pageTitle } from 'utils/common.util';
import { siteURL } from 'services/request';

const Navbar = dynamic(() => import('components/Navbar'));
const Profile = dynamic(() => import('components/Profile'));
const Head = dynamic(() => import('next/head'));

const ProfilePage: React.FC = () => {
  const router = useRouter();
  const { profileId, name } = router.query;
  const user = useSelector((state) => state.account.user);
  const url = `${siteURL}/profile/${profileId}/${name}`;
  const searchData = useSelector((state) => state.course.searchData);
  const data = [
    ...(searchData?.workshops || []),
    ...(searchData?.events || []).map((item) => ({ ...item, isWebinar: true })),
  ];

  const profile =
    profileId === 'user'
      ? user
      : data
          .map((item) => item.teachers.map((k) => k))
          .flat()
          .find((item) => item?.id.toString() === profileId);

  return (
    <>
      <Head>
        <title>{pageTitle(name)}</title>
        <meta name="description" content={name as string} />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1 user-scalable=no"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={url} />
      </Head>

      <Navbar />
      <Profile data={data} profile={profile} />
    </>
  );
};

export default ProfilePage;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getServerSideProps = async () => {
  return { props: {} };
};
